// extracted by mini-css-extract-plugin
module.exports = {"button":"ControlButton_button__16RRk","icon":"ControlButton_icon__3Uh_B"};